import React, { FC, ReactNode, useState } from 'react';

import PropTypes from 'prop-types';

import { carouselStyle, dotStyle, dotsWrapperStyle } from './helpers/styles';

interface TrialModalItemProps {
  children: ReactNode[];
}

const TrialModalCarousel: FC<TrialModalItemProps> = ({ children }) => {
  const [active, setActive] = useState(0);
  return (
    <div css={carouselStyle}>
      {children[active]}
      <div css={dotsWrapperStyle(children.length)}>
        {children.map((_, index) => {
          return (
            <div
              css={dotStyle(active === index)}
              data-testid={`TrialModalCarouselDot${index}`}
              key={`carousel-dot-${index}`}
              onClick={() => {
                setActive(index);
              }}
            ></div>
          );
        })}
      </div>
    </div>
  );
};

TrialModalCarousel.displayName = 'TrialModalCarousel';
TrialModalCarousel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export default TrialModalCarousel;
